@import (reference) '../../../../../constants/spacing.module.less';

.modalBody {
  padding: @space-16;
  max-width: 760px;
}

.modalHeaderText {
  font-weight: 400;
}

.modalFooter {
  padding: @space-16;
}
